let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("14Bbk")).then(() => parcelRequire('lXK09'));